import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// We don't need to import CSS here since it's handled by our Sass pipeline
export default class extends Controller {
  connect() {
    // Create the TomSelect instance with our configuration
    const ts = new TomSelect(this.element, {
      plugins: {
        remove_button: {
          title: "Remove this item",
          label: '×'
        }
      },
      hidePlaceholder: true,
      onItemAdd: function() {
        // If TomSelect is for a multi-select, we want to clear the input after adding an item
        if (this.settings.mode != "single") {
          this.setTextboxValue("")
          this.refreshOptions()
        }
      }
    });
  }
}

